<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    persistent
    dark
  >
    <v-card>
      <v-card-title>
        <h3 class="font-weight-regular">
          กงล้อเสี่ยงโชค
        </h3>
        <v-spacer />
        <v-btn
          @click="close"
          depressed
          dark
          icon
        >
          <v-icon>
            fas fa-times
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <center>
          <p class="mt-2">
            จำนวนหมุนฟรี
            <br>
            <span style="font-size: 1.5rem;">
              {{ Number(fortuneWheelData.round || 0) - Number(fortuneWheelData.played || 0) }}
            </span>
          </p>
          <fortune-wheel
            :verify="true"
            :prizes="prizes"
            :disabled="disabled"
            :prize-id="prize"
            he
            :canvas="{
              borderWidth: 1,
              borderColor: '#584b43',
              btnText: 'หมุน',
            }"
            @rotateStart="spin"
            @rotateEnd="onSpinStop"
          />
          <p class="mt-2">
            <profile>
              <template v-slot:default="{ profile }">
                <span style="font-size: 1.5rem;">
                  {{ profile.balance }}
                </span>
              </template>
            </profile>
            <br>
            เครดิตคงเหลือ
          </p>
        </center>
      </v-card-text>
      <div class="d-block">
        <center>
          <v-btn
            :class="`mx-1 ${useCredit ? 'purple' : ''}`"
            outlined
            x-large
            width="200px"
            @click="useCredit = true"
          >
            ใช้เครดิต
          </v-btn>
          <v-btn
            :class="`mx-1 ${!useCredit ? 'purple' : ''}`"
            outlined
            x-large
            width="200px"
            @click="useCredit = false"
          >
            ใช้สิทธิ์หมุนฟรี
          </v-btn>
        </center>
      </div>
      <v-card-actions class="justify-center">
          <div>
            <center>
              <h2 class="red--text">*** กติกาการเล่น ***</h2>
            </center>
            <ul>
              <li>
                หากท่านไม่มีจำนวนรอบหมุนฟรีท่านสามารถให้เครดิตหมุนโดยมีค่าหมุนครั้งละ 20 บาท
              </li>
              <li>
                หากท่านมีจำนวนรอบค้างอยู่และปิดหน้านี้ไป
                จะถือว่าท่าน<span class="red--text">สละสิทธิ์</span>ในการหมุนกงล้อที่เหลืออยู่
              </li>
              <li>
                หากการดึงข้อมูลเกิดความ
                <span class="red--text">ผิดพลาด</span>
                จะมีปุ่มให้ท่านดึงข้อมูลใหม่อีกครั้ง
              </li>
              <li>ฝากเงิน 200 ครั้งแรกของวันสิทธฺ์หมุนกงล้อฟรี 1 ครั้งต่อวัน</li>
              <!-- <li>รางวัลที่ได้รับจากการหมุนจะต้องทำเทิร์นก่อนถึงจะสามารถถอนได้</li>
              <li>
                หากท่านติดเทิร์นจากโปรโมชั่นอื่นแล้วทำการหมุนกงล้อ
                ยอดเทิร์นของกงล้อจะถูกบวกเข้ากับยอดเทรืน์ที่ท่านค้างอยู่
              </li> -->
            </ul>
            <!-- <center>
              <span class="red--text">วิธีคิดเทิร์น</span>
              <p>เทิร์น = (200 + ยอดที่ท่านได้โบนัสจากการหมุน) * 2</p>
            </center> -->
            <div>
              <v-spacer />
              <v-btn
                @click="close"
                depressed
                color="red"
                dark
                block
              >
                ปิด
              </v-btn>
            </div>
          </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  Component, Vue, Prop, Emit,
} from 'vue-property-decorator';
import FortuneWheel from 'vue-fortune-wheel';
import FortuneWheelService from '@/services/FortuneWheelService';
import 'vue-fortune-wheel/lib/vue-fortune-wheel.css';
import Profile from '@/connector/Profile.vue';

const fortuneWheelService = new FortuneWheelService();

@Component({
  components: {
    FortuneWheel,
    Profile,
  },
})
export default class FotuneWheelGame extends Vue {
  @Prop({ type: Boolean, required: true }) open;

  prize = 0;

  disabled = false;

  retry = false;

  useCredit = false;

  fortuneWheelData = {};

  set dialog(value) {
    this.close();
  }

  get dialog() {
    return this.open;
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  async spin(rotate) {
    try {
      this.disabled = true;
      const { data } = await fortuneWheelService.spin(this.useCredit);
      // eslint-disable-next-line max-len
      this.prize = this.prizes.findIndex((prize) => Number(prize.value) === Number(data.prizeId)) + 1;
      rotate();
      this.fortuneWheelData = { ...data.fortuneWheelData };
    } catch (e) {
      this.disabled = false;
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
  }

  async onSpinStop() {
    this.$store.commit('Snackbar/showNotification', { message: `ยินดีด้วยคุณได้รับรางวัล ${this.prizes[this.prize - 1].value} บาท`, error: false });
    this.$store.dispatch('Profile/fetchBalance');
    this.$store.dispatch('Profile/getProfile');
    this.disabled = false;
  }

  // eslint-disable-next-line class-methods-use-this
  get prizes() {
    return [
      {
        id: 1,
        name: '1000',
        value: 1000,
        bgColor: '#45ace9',
        color: '#ffffff',
        probability: 1,
      },
      {
        id: 2,
        name: '5',
        value: 5,
        bgColor: '#dd3832',
        color: '#ffffff',
        probability: 45,
      },
      {
        id: 3,
        name: '50',
        value: 50,
        bgColor: '#fef151',
        color: '#ffffff',
        probability: 13,
      },
      {
        id: 4,
        name: '500',
        value: 500,
        bgColor: '#45ace9',
        color: '#ffffff',
        probability: 1,
      },
      {
        id: 5,
        name: '10',
        value: 10,
        bgColor: '#fef151',
        color: '#ffffff',
        probability: 35,
      },
      {
        id: 6,
        name: '100',
        value: 100,
        bgColor: '#dd3832',
        color: '#ffffff',
        probability: 5,
      },
    ];
  }

  async fetchFortuneWheelData() {
    try {
      const { data } = await fortuneWheelService.fetchData();
      this.fortuneWheelData = { ...data };
      this.retry = false;
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
      this.retry = true;
    }
  }

  async created() {
    await this.fetchFortuneWheelData();
  }

  async destroyed() {
    // eslint-disable-next-line no-underscore-dangle
    if (this.fortuneWheelData._id) {
      // eslint-disable-next-line no-underscore-dangle
      await fortuneWheelService.invalidFortunWheel(this.fortuneWheelData._id, { eligible: 2 });
    }
  }
}
</script>
